import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppService } from 'src/app/app.service';
import { DeleteWarningComponent } from 'src/app/shared/components/delete-warning/delete-warning.component';
import { BIDPACK_ORIGIN_COLUMN_LSIT } from 'src/app/shared/constants/bidpack.constant';
import { bidpack_column_edit, BIDPACK_ORIGIN_INTERFACE } from 'src/app/shared/interfaces/bidpack.interface';
import { HttpService } from 'src/app/shared/services/http.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import { ChangeDetectorRef } from '@angular/core';
import { ImportDialogComponent } from 'src/app/shared/components/import-dialog/import-dialog.component';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { NavigationStart, Router } from '@angular/router';
import { FileErrorPopupComponent } from 'src/app/shared/components/file-error-popup/file-error-popup.component';
import { UnsavedAlertComponent } from 'src/app/shared/components/unsaved-alert/unsaved-alert.component';
import { take } from 'rxjs';

@Component({
  selector: 'app-edit-bidpack',
  standalone: false,
  templateUrl: './edit-bidpack.component.html',
  styleUrl: './edit-bidpack.component.scss'
})
export class EditBidpackComponent implements OnInit, AfterViewInit{

  public bidpackForm:FormGroup;
  public bidpackTypeList:any;
  public contactTableForm: FormGroup = new FormGroup({});
  displayedColumns: any = BIDPACK_ORIGIN_COLUMN_LSIT;
  BidpackDataSource:any;
  dataColList:any;
  dataSource:any = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>();
  filteredValues: any = { topFilter: false };
  bidpackCreateRes:any;

  @ViewChild(MatSort) sort: MatSort | any;
  allSelected = false;
  userData: any;
  operation: any;
  countryListArr: any;
  bidpackStatusList:any;
  actualData: any;
  changesBoo = false;
  popupBoo=false;
  importSub:any;
  isValuesChanged:boolean = false;

  constructor( public appService:AppService, private httpService:HttpService, private router:Router,
    private dialog:MatDialog, public tableService:TableService, private excelService:ExcelService) { 
    this.bidpackForm = new FormGroup({
      reference: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      bidpackType: new FormControl('', Validators.required),
      destination: new FormControl('',Validators.required),
      createdBy: new FormControl(''),
      modifiedBy: new FormControl(''),
      createdAt: new FormControl(''),
      modifiedAt:new FormControl('')
    });

    this.contactTableForm = new FormGroup({
      OriginCountryFilter: new FormControl(''),
      OriginPostcodeAreaFilter: new FormControl(''),
      OriginPostCodeFilter: new FormControl(''),
      OriginGSDBFilter: new FormControl(''),
    });
    this.dataColList = this.tableService.getTableColNames(this.displayedColumns);
    let userData = sessionStorage.getItem("user-data");
    
    this.userData = userData?JSON.parse(userData):null;
    this.BidpackDataSource = (history.state).data;
    this.operation = (history.state).operation;
    if(this.userData.RoleID === 3){
      this.operation = 'view'
    }
    if(this.operation === "edit" && this.BidpackDataSource.BidPackStatus === 'Terminated'){
      this.operation = this.BidpackDataSource.IsCopy?'edit':'view'
    }

    this.toUpdateOnField();
    this.getCountryList();
    this.onBidpackList();
    // this.router.events.subscribe((evt:any) =>{
    //   if (evt instanceof NavigationStart && this.router.url === '/home/bidpack/edit-bidpack') {
    //     const dialogRef = this.dialog.open(UnsavedAlertComponent, {
    //       disableClose: false,
    //     });
    //     dialogRef.afterClosed().subscribe((evt:any) => {
    //       if(evt.operation === "confirm"){
    //         // this.dataSource.data = this.dataSource.data.filter((item:any)=>!item.Selected);
    //         // this.dataSource = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>(this.dataSource.data);
    //       }
    //       else{
    //         evt.preventDefault();
    //       }
    //     })
    //   }
      
    // })
  }
  
  ngOnInit(): void {
  }

  onbackCall(){
    if(this.isValuesChanged){
      const dialogRef = this.dialog.open(UnsavedAlertComponent, {
              disableClose: false,
            });
            dialogRef.afterClosed().subscribe((evt:any) => {
              if(evt.operation === "confirm"){
                this.router.navigateByUrl('/home/bidpack')
              }
            })
    }
    else{
      this.router.navigateByUrl('/home/bidpack')
    }
    
  }

  ngAfterViewInit() {
    this.toUpdateOnField();
    this.getCountryList();
    if(this.operation !== 'add'){
      this.getBidPackOrigin();
    }
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.dataSource.data.map((item: any) => ({...item, Selected: true}));
    this.isValuesChanged = false;
    Object.keys(this.bidpackForm.controls).forEach(controlName => {
      this.bidpackForm.get(controlName)!.valueChanges.subscribe((value:any) => {
        this.isValuesChanged = true;
      });
    });

  }

  onKeyDown(event: KeyboardEvent, condition=false) {
    if(condition){
      this.changesBoo = true;
      return;
    }
    event.preventDefault();
}

onKeyDownOnTable(event: KeyboardEvent) {
  if(this.operation === 'view'){
  event.preventDefault();
  }
  this.changesBoo = true;
}

  toUpdateOnField() {
    this.bidpackForm.enable();
    this.contactTableForm.enable();
    if (this.operation === 'add') {
      this.bidpackForm.patchValue({
        createdBy:  (this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        modifiedAt: '',//this.appService.getWithFormatToday(),
        createdAt: this.appService.getWithFormatToday(),
        modifiedBy:  ''//(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        
      })
      return;
    }
    if (this.operation === 'view') { //|| (this.operation==='edit' && this.BidpackDataSource.BidPackStatus === 'Active')
      this.contactTableForm.disable();
      this.bidpackForm.disable();
    }
    this.bidpackForm.patchValue({
      reference: this.BidpackDataSource.BidPackReference,
      name: this.BidpackDataSource.BidPackName,
      bidpackType:(this.BidpackDataSource?.BidPackTypeID).split(",").map(Number),
      destination: this.BidpackDataSource.DestinationName,
      createdAt: this.tableService.checkOnInvalidDate(this.BidpackDataSource.CreatedOn),
      modifiedAt: this.tableService.checkOnInvalidDate(this.BidpackDataSource.ModifiedOn),
      createdBy: this.BidpackDataSource.CreatedBy,
      modifiedBy: this.BidpackDataSource.ModifiedBy
    })
  }

  isDuplicated(data:any) {
    // const filteredData = data.filter((item:any, index:any, array:any) => {
    //   if (item.OriginPostcodeArea === "" && item.OriginPostCode === "" && item.OriginGSDB === "") {
    //     // Check if CountryID is unique
    //     return !array.some((otherItem:any, otherIndex:any) => otherIndex !== index && otherItem.CountryID === item.CountryID);
    //   } else {
    //     // Check if combination is unique
    //     console.log("item",!array.some(
    //       (otherItem:any, otherIndex:any) =>
    //         otherIndex !== index &&
    //         otherItem.CountryID === item.CountryID &&
    //         otherItem.OriginPostcodeArea === item.OriginPostcodeArea &&
    //         otherItem.OriginPostCode === item.OriginPostCode &&
    //         otherItem.OriginGSDB === item.OriginGSDB
    //     ));
        
    //     return !array.some(
    //       (otherItem:any, otherIndex:any) =>
    //         otherIndex !== index &&
    //         otherItem.CountryID === item.CountryID &&
    //         otherItem.OriginPostcodeArea === item.OriginPostcodeArea &&
    //         otherItem.OriginPostCode === item.OriginPostCode &&
    //         otherItem.OriginGSDB === item.OriginGSDB
    //     );
    //   }
    // });    

    // console.log("filteredData",filteredData);
    
    const uniqueItems = new Set();
  for (const item of data) {
    const { CountryID, OriginPostcodeArea, OriginPostCode, OriginGSDB } = item;
    const itemKey = `${CountryID}-${OriginPostcodeArea}-${OriginPostCode}-${OriginGSDB}`;
    if (uniqueItems.has(itemKey)) {
      return true;
    }
    uniqueItems.add(itemKey);
  }
  return false;
  }

  onCheckValue(e:any,ele:any,order:any){
    this.changesBoo = true;
    this.isValuesChanged = true;
    if(ele === 'OriginCountry'){
      this.dataSource.data[order]['CountryID']=Number(e.value);
      this.dataSource.data[order]['OriginCountry']=this.countryListArr.find((i:any)=>i.CountryID === Number(e.value)).CountryName;  
      return;
    }
    this.dataSource.data[order][ele]=e.value;
  }
  onDelete() {
    if (this.operation === 'view') {
      return;
    }
    this.tableService.deleteItem('Bidpack', 'BidPackID',this.BidpackDataSource.BidPackID,this);
  }
  onCopy() {
    if (this.operation === 'view') {
      return;
    }
    this.bidpackForm.enable();
    this.contactTableForm.enable();
    this.changesBoo = true;
    this.operation = 'add';
    // this.bidpackForm.get('reference')?.setValue('')
    this.bidpackForm.patchValue({
      reference:'',
      modifiedBy:'',
      modifiedAt:''
    })
   

  }

  checkOnCountryWithZipCode(){
    const foundDuplicate = this.dataSource.data.some((item:any, index:any, array:any) => {
      if (item.OriginPostcodeArea === "" && item.OriginPostCode === "" && item.OriginGSDB === "") {
        const isDuplicate = array.some(
          (otherItem:any, otherIndex:any) => otherIndex !== index && otherItem.CountryID === item.CountryID
        );
        if (isDuplicate) {
          this.httpService.openSnackBar(`${item.OriginCountry} is already exist with no origin details.`);
          return true;
        }
      }
      return false;
    });
  
    return foundDuplicate;
  }

  onSave() {    
    if (this.operation === 'view'|| this.userData.RoleID === 3) {
      return;
    }
    let find:any = null 
    find= this.tableService.bidpackDBSource?.find((item:any)=>(item.BidPackReference).toLowerCase() === (this.bidpackForm.get('reference')?.value).toLowerCase());
    if(find && this.operation === "add"){
      this.httpService.openSnackBar('Bidpack Reference Already Exist');
      return;
    }

    // if((this.operation === 'add')&& this.BidpackDataSource &&((this.bidpackForm.get('reference')?.value).toLowerCase() === (this.BidpackDataSource?.BidPackReference).toLowerCase())){
    //   // if(this.bidpackForm.get('reference')?.value === this.BidpackDataSource.BidPackReference){
    //     this.httpService.openSnackBar('Bidpack Reference Already Exist');
    //     return;
    //   // }
    // }
    if (this.bidpackForm.invalid) {
      this.httpService.openSnackBar('Please fill all the required Fields')
      return;
    }
        
    if(this.dataSource.data.some((item:any)=>item.CountryID === 0)){
      this.httpService.openSnackBar('Please Choose Country Origin')
      return;
    }
    if(this.dataSource.data.length ===0){
      this.httpService.openSnackBar('Please Add Atleast One Country Origin')
      return;
    }

    if(this.checkOnCountryWithZipCode()){      
      return;
    }

    if(this.isDuplicated(this.dataSource.data)){
      this.httpService.openSnackBar('Country Origin value is duplicated!')
      return;
    }

    let body = {
      "BidPackID":this.operation === 'add' ?null:(this.operation === "edit" && this.BidpackDataSource.BidPackStatus === 'Terminated' && this.BidpackDataSource.IsCopy?null:this.BidpackDataSource.BidPackID),
      "BidPackReference": this.bidpackForm.get('reference')?.value,	
      "BidPackName"	:this.bidpackForm.get('name')?.value,	
      "DestinationName":this.bidpackForm.get('destination')?.value?this.bidpackForm.get('destination')?.value:'',	
      "BitPackTypeID":(this.bidpackForm.get('bidpackType')?.value).join(","),	
      "UserEmail"	:this.userData.Email,		
      "BidPackStatusID":this.operation === 'add'?(this.bidpackStatusList.find((i:any)=> i.LookUpName=== 'Not Active')).LookUpID:(this.bidpackStatusList.find((i:any)=> i.LookUpName=== this.BidpackDataSource.BidPackStatus)).LookUpID,
    }

    this.appService.isLoading = true;
    this.httpService.setBidpackDetails(body)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          if(res[0].DuplicateFlag === 0){
            this.bidpackCreateRes = res[0].BidPackID;//this.operation==="add"?res[0].BidPackID:0;
            this.setCountryList();
          }
          else{
              this.httpService.openSnackBar(res[0].MSG);
          }
        }
      })
  }

  setCountryList(){
    this.dataSource.data = this.dataSource.data.map((item:any)=>{return {...item, Selected:false, UserEmail: this.userData.Email}});
    // if(this.operation === 'add'){
    this.dataSource.data.forEach((item:any)=>{item.BidPackID = this.bidpackCreateRes});
    // }    
    
    this.appService.isLoading = true;
    this.httpService.setBidpackCountry(this.dataSource.data)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          // this.operation="edit";
          // this.BidpackDataSource.BidPackReference = this.bidpackForm.get('reference')?.value;
          this.httpService.openSnackBar('Bidpack Details Updated Successfully')
          this.router.navigateByUrl('/home/bidpack')
        }
      })
  }

  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList()
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.countryListArr = res;
          this.countryListArr.sort((a:any, b:any) => ((a.CountryName).toLowerCase() > (b.CountryName).toLowerCase()) ? 1 : -1);  
        }
      })
  }

  getBidPackOrigin() {
    this.appService.isLoading = true;
    this.httpService.getBidpackCountry(this.BidpackDataSource.BidPackID)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          res = res.map((item: any) => ({...item, Selected: false, UserEmail: this.userData.Email}));
          this.dataSource = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>(res);
          this.actualData = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>(res);
          this.dataSource.sort = this.sort;
          this.tableService.checkWithFilter(this)
        }
      })
  }

  onBidpackList(){
    this.appService.isLoading = true;
    this.httpService.getListOfData('Bidpack')
    .subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.bidpackTypeList = res.filter((item: any) => item.Category === "BidPackType");
        this.bidpackStatusList = res.filter((item: any) => item.Category === "BidPackStatus");
      }
    })
  }

  onDeleteRow(){
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: { header: "Delete Country Origin", msg: "Are you sure you want to delete this Country Origin?" }
    });
    dialogRef.afterClosed().subscribe((evt:any) => {
      if(evt.operation === "confirm"){
        this.isValuesChanged = true;
        this.dataSource.data = this.dataSource.data.filter((item:any)=>!item.Selected);
        this.dataSource = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>(this.dataSource.data);
      }
    })
  }
  onAddNewRow(){
    this.isValuesChanged = true;
    this.dataSource.data.unshift({
      OriginCountry: '', OriginPostcodeArea: '', OriginPostCode: '', OriginGSDB: '', BidPackID: this.operation==="add"?0:this.BidpackDataSource.BidPackID, 
      CountryID: 0, Selected:false, UserEmail:this.userData.Email
    });    
    this.dataSource.data = [...this.dataSource.data];
  }
  onExportdata(){
    const exportData= this.dataSource.data.filter((data:any)=>data.Selected).map((item:any) => ({
      ...item,
      ...{"DestinationName":this.BidpackDataSource.DestinationName,
        "CreatedOn":this.BidpackDataSource.CreatedOn,
        "BidPackStatus":this.BidpackDataSource.BidPackStatus
      }
    }));
    this.tableService.exportToExcel(exportData, bidpack_column_edit , 'BidpackExport');
  }
  onImportData(){
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      disableClose: false,
      data: { screen: "bidpack" }
      
    });

    this.importSub =this.excelService.fileDataEmitter.subscribe((evt:any)=>{
      // console.trace();
      if(evt === "bidpack"){
        this.isValuesChanged = true;
        let val = this.excelService.data.find((item: any) => {
          if (this.countryListArr.find((i: any) => (i.CountryName)?.toLowerCase() === (item.Country)?.toLowerCase())?.CountryID === undefined) {
            this.errorFile({title:'Data error present in the file',msg:'Please upload the file with correct value'});
            return true; // Break the loop
          }
          return false;
        });
  
        if (val) {
          dialogRef.afterClosed().subscribe(evt => {
            this.importSub.unsubscribe();
          });
          return; // Exit the function
        }

        let excelData:any 
        if(this.excelService.data.length>0){
        excelData = this.excelService.data.map((item:any)=>{
          return{
            'BidPackID': this.operation==="add"? 0:this.BidpackDataSource.BidPackID,
          "CountryID": this.countryListArr.find((i:any)=>(i.CountryName)?.toLowerCase() === (item.Country)?.toLowerCase())?.CountryID,
          'OriginCountry': item.Country,
          'OriginGSDB': item["Supplier GSDB"]!= null?''+item["Supplier GSDB"]:'',
          'OriginPostCode': item['Zipcode']!=null?''+item['Zipcode']:'',
          'OriginPostcodeArea': item["Zip Area"]!=null?''+item["Zip Area"]:'',
          'Selected':false,
          'UserEmail':this.userData.Email
          }
      });
      
    }
    else{      
      this.errorFile({title:'File format not Supported',msg:'Please upload the correct .xlsx file'});
      return;
    }

      this.bidpackForm.valueChanges.subscribe(value => {
        this.changesBoo=true
      });
      
      // const hasValue = excelFirstVal.hasOwnProperty("Supplier GSDB") && excelFirstVal.hasOwnProperty("Zipcode") && excelFirstVal.hasOwnProperty("Zip Area");
      //   if(!hasValue){
      //     this.errorFile();
      //     return;
      //   }
      if(this.isDuplicated([...this.dataSource.data, ...excelData])){
        // this.httpService.openSnackBar('Country Origin value is duplicated!')
        this.errorFile({title:'Duplicate records detected in the file',msg:'Please update the file with correct data'});
        return;
      }
        this.dataSource.data = [...this.dataSource.data, ...excelData];
        this.dataSource = new MatTableDataSource<BIDPACK_ORIGIN_INTERFACE>(this.dataSource.data);
      }
    });
    dialogRef.afterClosed().subscribe(evt => {
      this.importSub.unsubscribe();
    })
  } 
  
  
  
errorFile(obj:any){
  // this.importSub.unsubscribe();
  const dialogRef = this.dialog.open(FileErrorPopupComponent, {
    disableClose: false,
    data:{
      title:obj.title,
      message:obj.msg
    }
  });
  dialogRef.afterClosed().subscribe(evt => {
    // dialogRef.close();
    if(evt?.operation === 'try'){
      // dialogRef.close();
      this.onImportData();
    }
  })
}
}

